<template>
  <modal-pop
    :opened.sync="error.active"
    confirm="MCOM-0000003"
    @confirm="error.errType=='crcValidErr'?goToPage():retry()"
    class="error"
    @touchstart.native.stop="() => {}">
    <template #content>
      <div v-if="error.errType=='crcValidErr'">{{$t(error.errMsgI18n)}}</div>
      <div v-else>
        <div class="error-code">
          <i class="icon icon-error" />
          <div>
            <span>Error Code</span>
            <strong>{{ error.errCode }}</strong>
          </div>
        </div>
        <p v-if="error.errCode == 'B99Z0082'" v-html="error.errMsg"></p>
        <p v-else v-html="error.errMsg"></p>
        <p>{{ /*전화상담*/ $t("MCOM-0000031") }}</p>
        <div class="btn-area" v-if="operGroupCd == 'VN2'">
          <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_oghni`))">
            <i class="icon icon-call" />
            {{ $t(`지점별전화번호_oghni`) }}
          </button>
        </div>
        <div class="btn-area" v-else>
          <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_${siteCode}`))">
            <i class="icon icon-call" />
            {{ $t(`지점별전화번호_${siteCode}`) }}
          </button>
        </div>
      </div>
    </template>
  </modal-pop>
</template>
<script>
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
export default {
  name: "ErrorModal",
  extends: Common,
  methods: {
    retry() {
      this.setErrorModal(false);
    },
    goToPage() {
      if (this.$route.name !== "main") {
        this.$bridge.qrScanForTransfer(this.operGroupCd);
      }
      this.setErrorModal(false);
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
  },
};
</script>
